/*
 * DynamicFieldOptionForm Messages
 *
 * This contains all the text for the DynamicFieldOptionForm component.
 */

import { defineMessages } from 'react-intl';

export const scope =
  'src.pages/DynamicFieldsPage/components/DynamicFieldOptionForm';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Possible values (options)',
  },
  yesLabel: {
    id: `${scope}.yesLabel`,
    defaultMessage: 'Yes',
  },
  noLabel: {
    id: `${scope}.noLabel`,
    defaultMessage: 'No',
  },
  labelEnColumnLabel: {
    id: `${scope}.labelEnColumnLabel`,
    defaultMessage: 'Label EN',
  },
  labelDeColumnLabel: {
    id: `${scope}.labelDeColumnLabel`,
    defaultMessage: 'Label DE',
  },
  positionColumnLabel: {
    id: `${scope}.positionColumnLabel`,
    defaultMessage: 'Position',
  },
  addButton: {
    id: `${scope}.addButton`,
    defaultMessage: 'Add',
  },
  editTooltip: {
    id: `${scope}.editTooltip`,
    defaultMessage: 'Edit',
  },
  deleteTooltip: {
    id: `${scope}.deleteTooltip`,
    defaultMessage: 'Delete',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  saveButton: {
    id: `${scope}.saveButton`,
    defaultMessage: 'Save',
  },
  dynamicOptionSaved: {
    id: `${scope}.dynamicOptionSaved`,
    defaultMessage: 'Selectable value (option) saved successfully',
  },
  dynamicOptionDeleted: {
    id: `${scope}.dynamicOptionDeleted`,
    defaultMessage: 'Selectable value (option) deleted successfully',
  },
  deleteDynamicFieldConfirmMessage: {
    id: `${scope}.deleteDynamicFieldConfirmMessage`,
    defaultMessage: 'Are you sure you want to delete this Field?',
  },
});
